export default __webpack_public_path__ + "static/media/home_header_public_sector.9cd741be.svg";